function getApiServer() {
  if (window.location.port && parseInt(window.location.port) === 3000) {
    return 'https://design-board.localdev'
  }
  return window.location.origin
}

export function fetchJson (url) {
  return fetch(url).then(res =>
    res.json()
  )
}

export function getConfig () {
  return fetchJson(`${getApiServer()}/api/design-board/config.json`)
}

export function getSampleGroups () {
  return fetchJson(`${getApiServer()}/api/design-board/sample-groups.json`)
}

export function getSamples(sampleGroupId) {
  return fetchJson(`${getApiServer()}/api/design-board/sample-group/${sampleGroupId}.json`)
}

export function saveBoard(designBoard) {
  return fetch(`${getApiServer()}/api/design-board/boards.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(designBoard)
  }).then(res =>
    res.json()
  )
}